import React, { useEffect } from "react";
import { Card, Col, Divider, Row, Typography, Table } from "antd";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    currencyData,
    setCurrencyCount,
    configureCurrencyTableSource,
    setConfigureCurrencyTableSource,
    officeData,
    branchConfigList,
    glAccountData
  } = props;

  useEffect(() => {
    console.log(configureCurrencyTableSource);
console.log(formData);
console.log(glAccountData);
console.log(formData?.configForm?.vaultGl);
console.log( glAccountData?.find(
  (item) => item.value === formData.configForm.vaultGl
).label);

  }, []);

  const data = {
    configForm: [
      {
        name: "Branch",
        value: formData?.configForm?.operationId
          ? branchConfigList?.find(
              (item) => item.value === formData.configForm.operationId
            ).label
          : "-",
      },
      {
        name: "Vault GL",
        value: formData?.configForm?.vaultGl
        ? glAccountData?.find(
            (item) => item.value === formData.configForm.vaultGl
          ).label
        : "-",
      },
      {
        name: "Till GL",
        value: formData?.configForm?.tillGl
        ? glAccountData?.find(
            (item) => item.value === formData.configForm.tillGl
          ).label
        : "-",
      },
    ],
  };

  const columns = [
    [
      {
        key: " 1",
        title: "Vault Currency",
        dataIndex: "currencyCode",
      },
      {
        key: " 2",
        title: "Maximum Vault Limit",
        dataIndex: "vaultMaxAmount",
      },
    ],
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* AUTH FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Vault Config Info"}
        </Divider>
        {data.configForm.map((detail, index) => {
          // console.log("detail", detail);

          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* LIMITS FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Vault Currencies"}
        </Divider>
        <Table
          pagination={false}
          columns={columns[0]}
          dataSource={configureCurrencyTableSource}
        />
      </div>
    </Card>
  );
};

export default Preview;
